(function () {

    "use strict";

    console.log("🧠 Ankur Review Engine Loaded");

    // ============================================
    // Seeded Random Generator
    // ============================================

    function mulberry32(seed) {

        return function () {

            let t = seed += 0x6D2B79F5;

            t = Math.imul(
                t ^ t >>> 15,
                t | 1
            );

            t ^= t + Math.imul(
                t ^ t >>> 7,
                t | 61
            );

            return (
                (t ^ t >>> 14) >>> 0
            ) / 4294967296;

        };

    }

    // ============================================
    // Review Count
    // ============================================

    function getReviewCount(random) {

        const reviewSeed = random();

        if (reviewSeed < 0.25) return 0;
        if (reviewSeed < 0.40) return 1;
        if (reviewSeed < 0.50) return 2;
        if (reviewSeed < 0.58) return 3;
        if (reviewSeed < 0.65) return 4;
        if (reviewSeed < 0.71) return 5;
        if (reviewSeed < 0.76) return 6;
        if (reviewSeed < 0.81) return 7;
        if (reviewSeed < 0.85) return 8;
        if (reviewSeed < 0.89) return 10;
        if (reviewSeed < 0.92) return 12;
        if (reviewSeed < 0.95) return 15;
        if (reviewSeed < 0.97) return 18;
        if (reviewSeed < 0.99) return 20;

        return 25;

    }

    // ============================================
    // Single Review Rating
    // ============================================

    function getReviewRating(random, totalReviews) {

        const value = random();

        if (totalReviews <= 2) {

            if (value < 0.60) return 5;
            if (value < 0.80) return 4;
            if (value < 0.90) return 3;
            if (value < 0.97) return 2;

            return 1;

        }

        if (value < 0.20) return 5;
        if (value < 0.40) return 4;
        if (value < 0.60) return 3;
        if (value < 0.80) return 2;

        return 1;

    }

    // ============================================
    // Average Rating
    // ============================================

    function getAverageRating(random, totalReviews) {

        if (totalReviews === 0) {

            return 0;

        }

        let totalStars = 0;

        for (let i = 0; i < totalReviews; i++) {

            totalStars += getReviewRating(
                random,
                totalReviews
            );

        }

        return Number(
            (
                totalStars /
                totalReviews
            ).toFixed(1)
        );

    }

    // ============================================
    // Public API
    // ============================================

    window.ANKUR_REVIEW_ENGINE = {

        getSummary(productId) {

            const random =
                mulberry32(
                    Number(productId)
                );

            const count =
                getReviewCount(random);

            const average =
                getAverageRating(
                    random,
                    count
                );

            return {

                productId: Number(productId),

                count,

                average

            };

        },

        getReviewRating(productId, totalReviews) {

            const random =
                mulberry32(
                    Number(productId)
                );

            getReviewCount(random);

            return getReviewRating(
                random,
                totalReviews
            );

        }

    };

})();